import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
// TODO: Install react-helmet for SEO meta tags: npm install react-helmet
// import { Helmet } from 'react-helmet';

// Import all homepage sections
import Navigation from '../../components/Homepage/Navigation';
import Hero from '../../components/Homepage/Hero';
import ProblemSection from '../../components/Homepage/ProblemSection';
import Features from '../../components/Homepage/Features';
import MiniApps from '../../components/Homepage/MiniApps';
import HowItWorks from '../../components/Homepage/HowItWorks';
import DocsSection from '../../components/Homepage/DocsSection';
import Pricing from '../../components/Homepage/Pricing';
import Testimonials from '../../components/Homepage/Testimonials';
import FAQ from '../../components/Homepage/FAQ';
import Footer from '../../components/Homepage/Footer';

const HomepageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #000000;
  color: white;
  overflow-x: hidden;
  padding-top: 0; /* Navigation is fixed, so no padding needed */
`;

const Homepage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('🏠 Homepage component mounted');
    
    // Reset any existing scroll locks from other pages
    document.body.style.overflow = 'unset';
    document.documentElement.style.overflow = 'unset';
    document.body.style.position = 'static';
    document.body.style.width = 'auto';
    document.body.style.height = 'auto';
    document.body.style.touchAction = 'auto';

    // Smooth scrolling for anchor links
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const handleGetStarted = () => {
    // Navigate to the existing login/signup flow for new users
    navigate('/login');
  };

  const handleSignIn = () => {
    // Navigate to the existing login/signup flow for existing users
    navigate('/login');
  };

  const handleLearnMore = () => {
    // Scroll to features section
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const navHeight = 80; // Account for fixed navigation height
      const elementPosition = section.offsetTop - navHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    document.title = 'DIZEE - AI-Powered Workspace for Music Professionals';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'The AI-powered workspace that knows your catalogue, touring, marketing, revenue and audience and turns it into actions. Your music business on autopilot.');
    }
  }, []);

    return (
    <HomepageContainer>
      {console.log('🎨 Rendering Homepage container')}
      
      {/* Navigation */}
      <Navigation 
        onSignIn={handleSignIn}
        onScrollToSection={scrollToSection}
      />

      {/* Hero Section */}
      <Hero 
        onGetStarted={handleGetStarted}
        onSignIn={handleSignIn}
        onLearnMore={handleLearnMore}
      />

        {/* Problem Section */}
        <section id="problem">
          <ProblemSection />
        </section>

        {/* Features Section - Let DIZEE work for you */}
        <section id="features">
          <Features />
        </section>

        {/* Mini Apps Section */}
        <section id="apps">
          <MiniApps />
        </section>

        {/* How It Works Section */}
        <section id="how-it-works">
          <HowItWorks />
        </section>

        {/* Documentation Section */}
        <section id="docs">
          <DocsSection />
        </section>

        {/* Pricing Section */}
        <section id="pricing">
          <Pricing />
        </section>

        {/* Testimonials Section */}
        <section id="testimonials">
          <Testimonials />
        </section>

        {/* FAQ Section */}
        <section id="faq">
          <FAQ />
        </section>

        {/* Footer */}
        <Footer onGetStarted={handleGetStarted} onSignIn={handleSignIn} />
      </HomepageContainer>
  );
};

export default Homepage; 